import { useState } from 'react';

export const useDragAndDrop = (items, onReorder = null) => {
  const [draggedItem, setDraggedItem] = useState(null);
  const [draggedOverItem, setDraggedOverItem] = useState(null);

  const handleDragStart = (e, index) => {
    setDraggedItem(index);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    
    if (index !== draggedItem) {
      setDraggedOverItem(index);
    }
  };

  const handleDragLeave = () => {
    setDraggedOverItem(null);
  };

  // Helper function to move an item from one index to another
  const moveItem = (array, fromIndex, toIndex) => {
    const newArray = [...array];
    const item = newArray.splice(fromIndex, 1)[0];
    newArray.splice(toIndex, 0, item);
    return newArray;
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    
    if (draggedItem === null || draggedItem === dropIndex) {
      setDraggedItem(null);
      setDraggedOverItem(null);
      return;
    }

    const draggedItemData = items[draggedItem];
    
    // Use the simple move function
    const newItems = moveItem(items, draggedItem, dropIndex);
    
    // Call the onReorder callback with details for toast notification and state update
    if (onReorder && draggedItemData) {
      onReorder({
        newItems,
        itemName: draggedItemData.submitted_by_name || 'Question',
        fromPosition: draggedItem + 1,
        toPosition: dropIndex + 1,
      });
    }
    
    setDraggedItem(null);
    setDraggedOverItem(null);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    setDraggedOverItem(null);
  };

  const getDragProps = (index) => ({
    draggable: true,
    onDragStart: (e) => handleDragStart(e, index),
    onDragOver: (e) => handleDragOver(e, index),
    onDragLeave: handleDragLeave,
    onDrop: (e) => handleDrop(e, index),
    onDragEnd: handleDragEnd,
  });

  const isDragging = (index) => draggedItem === index;
  const isDraggedOver = (index) => draggedOverItem === index;

  return {
    getDragProps,
    isDragging,
    isDraggedOver,
  };
}; 